import artifact from '$houdini/artifacts/CreateVehicle'
import { MutationStore } from '../runtime/stores/mutation'

export class CreateVehicleStore extends MutationStore {
	constructor() {
		super({
			artifact,
		})
	}
}
